import { Controller } from "@hotwired/stimulus"

// Two-state collapse with a class flag on the wrapper so CSS can flip the
// label, rotate a chevron, etc. without relying on :has(). Cleaner than the
// generic `toggle` controller because it makes the open/closed state
// observable on the controller's root element.
export default class extends Controller {
  static targets = ["content"]
  static classes = ["expanded"]

  toggle() {
    if (!this.hasContentTarget) return
    const isHidden = this.contentTarget.classList.toggle("hidden")
    const expandedCls = this.hasExpandedClass ? this.expandedClass : "is-expanded"
    this.element.classList.toggle(expandedCls, !isHidden)
  }
}
